import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M5.207 2.738c-1.871-.873-3.831 1.026-3.02 2.924l2.586 6.044a.75.75 0 0 1 0 .59L2.188 18.34c-.812 1.898 1.148 3.797 3.02 2.924l15.494-7.224c1.732-.807 1.732-3.27 0-4.078zm-1.64 2.334c-.27-.633.382-1.265 1.006-.975l15.495 7.224a.75.75 0 0 1 0 1.36L4.573 19.905c-.624.29-1.277-.342-1.006-.975l2.585-6.044q.03-.069.054-.138h4.735a.75.75 0 0 0 0-1.5H6.204a2 2 0 0 0-.051-.132z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }